"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerGroup = void 0;
var _reactI18next = require("react-i18next");
var _react = _interopRequireDefault(require("react"));
var _ticker = require("../../../../ticker");
var _ui = require("../../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TickerGroup = function TickerGroup(_ref) {
  var ticker = _ref.ticker,
    tickers = _ref.tickers,
    balances = _ref.balances,
    onTickerChange = _ref.onTickerChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('chooseCurrencyToSend')), /*#__PURE__*/_react.default.createElement(_ticker.TickerSelectInput, {
    value: ticker,
    tickers: tickers,
    balances: balances,
    onChange: onTickerChange
  }));
};
exports.TickerGroup = TickerGroup;